define.alias("shared/components/shared/wizard", "preview-grid/components/shared/wizard");